<template>
	<div class="order-row member-page">
		<div class="order-row-wrap">
			<div class="img-wrap">
				<ximg :src="row.product.thumbnail" :ariaLabel="row.product.name + ' product thumbnail'" role="img" />
			</div>
			<div class="info-wrap">
				<div class="product-info-wrap">
					<div class="product-link">
						<router-link :to="path">{{ row.product.name }}</router-link>
					</div>
					<div class="sub-title">
						<span v-if="row.product.ifsId">
						{{ t('CODE', row.product.id) }} ({{ row.product.ifsId }})
						</span>
						<span v-else>
						{{ t('CODE', row.product.id) }}
						</span>
						<span v-if="! isReleased">
							[Release: {{ releaseDate }}]
						</span>
						<span v-else-if="isActive" class="small long-delivery-row">
							<delivery-notice :displayText="t('LONG_DELIVERY_TIME_SHORT')" :infoText="row.product.longDeliveryNotice"/>
						</span>
					</div>
					<div class="product-stock">
						<span v-if="hasStockInfo" :class="stockClass" />
						{{ row.quantity }} st à {{ unitPriceFormatted }}
					</div>
				</div>
				<icon-button
					v-if="showRemoveBtn()"
					variant="remove"
					size="tiny"
					@click="removeRow"
				/>
			</div>
		</div>
		<div v-if="row.insuranceInfo && row.insuranceInfo.insured" class="mt-2 pb-3">
			<order-row-insurance-info :insuranceInfo="row.insuranceInfo" />
		</div>
		<div v-if="row.hasSubscription" class="mt-2 pb-3">
			<order-row-subscriptions :subscriptionProducts="row.subscriptionData" />
		</div>
		<workshop-service-report v-if="showServiceReport"
			:infoText="row.product.customerWorkshopInfo.text || undefined"
			:pageLink="row.product.customerWorkshopInfo.url"
		/>
	</div>
</template>

<script>
import { t } from 'datastore/i18n';
import { isProductReleased, releaseToString, formatPrice, urlFormat } from 'utils';

import bus from 'eventbus';

export default {// @TODO valuta på priset

	props: {
		row: {},
		activeStatus: {
			type: Boolean,
			default: true,
		},
	},
	data () {
		return {
			t: t.prefix('PRODUCT'),
			isProductReleased,
			releaseToString,
			formatPrice,
			urlFormat,
		};
	},
	methods: {
		removeRow (ev) {
			bus.$emit('modal.confirm', 'Vill du ta bort "' + this.row.product.name + '" från din order?', () => {
				bus.$emit('removeFromOrder', this.row.product);
			}, null, 'Ta bort', 'Avbryt', true);
		},
		showRemoveBtn () {
			if (this.row.locked) {
				return false;
			}
			if (this.$route.name !== 'checkout-complete') {
				return false;
			}
			return true;
		},
	},
	computed: {
		isReleased () {
			if (! this.row.product.release) {
				return true; // @TODO dubbelkolla
			}
			return isProductReleased(this.row.product.release);
		},
		releaseDate () {
			if (! this.row.product.release) {
				return true;
			}
			return releaseToString(this.row.product.release);
		},
		isActive() {
			return (!this.row.inStock && this.row.product.longDeliveryNotice !== null && this.activeStatus == true);
		},
		unitPriceFormatted () {
			const currency = 'SEK';
			return formatPrice(this.row.unitPrice, currency);
		},
		path () {
			return this.$router.route({
				name: 'product',
				params: {
					id: this.row.product.id,
					name: urlFormat(this.row.product.name),
				},
			});
		},
		hasStockInfo () {
			return 'inStock' in this.row;
		},
		stockClass () {
			if (this.row.product.id === 236123) {
				return;
			}
			if (this.row.inStock) {
				return 'stock-icon-instock';
			} else if (! this.isReleased) {
				return 'stock-icon-notreleased';
			} else {
				return 'stock-icon-outofstock';
			}
		},
		showServiceReport () {
			let now = Math.floor((new Date().getTime()) / 1000);
			return this.row.sentDate && now >= (this.row.sentDate + (86400 * 30)) && this.row.product.customerWorkshopInfo?.url;
		},
	},
};
</script>
